(function () {
  angular.module('MktzapApp.Factories').factory('HsmService', HsmService);

  HsmService.$inject = ['$resource'];

	 function HsmService ($resource) {
    return $resource(apiUrl + '/hsm', {}, {
      all: {
        'method': 'GET',
        'params': {},
        'isArray': true
      }
    });
  }
})();
